/**
 * @engine/vfx - Operator Nodes
 *
 * Math, random, and utility nodes available in any context.
 */

import type { VFXNodeDefinition } from '../../types';
import { dataPort } from '../../types';

/**
 * Operator node definitions.
 */

export const SAMPLING_NODES: readonly VFXNodeDefinition[] = [

  {
    id: 'vfx.operator.sample_gradient',
    name: 'Sample Gradient',
    category: 'operator',
    contexts: [],
    description: 'Sample color from gradient',
    color: '#E91E63',
    inputs: [
      dataPort('gradient', 'Gradient', 'gradient'),
      dataPort('t', 'T', 'float', { defaultValue: 0.5, range: { min: 0, max: 1 } }),
    ],
    outputs: [
      dataPort('color', 'Color', 'color'),
    ],
    shader: {
      code: `color = gradient(t);`,
    },
  },

  {
    id: 'vfx.operator.sample_curve',
    name: 'Sample Curve',
    category: 'operator',
    contexts: [],
    description: 'Sample value from curve',
    color: '#E91E63',
    inputs: [
      dataPort('curve', 'Curve', 'curve'),
      dataPort('t', 'T', 'float', { defaultValue: 0.5, range: { min: 0, max: 1 } }),
    ],
    outputs: [
      dataPort('value', 'Value', 'float'),
    ],
    shader: {
      code: `value = curve(t);`,
    },
  },

  {
    id: 'vfx.operator.sample_texture',
    name: 'Sample Texture',
    category: 'operator',
    contexts: [],
    description: 'Sample color from texture (nearest texel at UV)',
    color: '#E91E63',
    inputs: [
      dataPort('texture', 'Texture', 'texture2d'),
      dataPort('uv', 'UV', 'vec2', { defaultValue: { x: 0.5, y: 0.5 } }),
    ],
    outputs: [
      dataPort('color', 'Color', 'color'),
    ],
    shader: {
      // Compute stages have no sampler binding — load the nearest texel.
      code: `
        uint2 dims = textureSize(texture);
        float2 clamped = clamp(uv, float2(0.0), float2(1.0));
        uint2 coord = min(uint2(clamped * float2(dims)), dims - 1u);
        color = texture.Load(int3(int(coord.x), int(coord.y), 0));
      `,
    },
  },
];
